// OpeningData.js
export const positions = [

   
    {
        title: "Graphic Designer",
        location: "India, M.P",
        experience: "3+ Years Experience",
        apply_url: "dummyurl"

    },
    {
        title: "Content Writer",
        location: "India, M.P",
        experience: "3+ Years Experience",
        apply_url: "dummyurl"

    },
    {
        title: "HR Executive",
        location: "India, M.P",
        experience: "3+ Years Experience",
        apply_url: "dummyurl"

    },
    {
        title: "Project Coordinator",
        location: "India, M.P",
        experience: "3+ Years Experience"
    },
    {
        title: "Web Developer",
        location: "India, M.P",
        experience: "3+ Years Experience"
    },
    {
        title: "Android Developer",
        location: "India, M.P",
        experience: "3+ Years Experience"
    }
];